import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'
import JwPagination from 'jw-vue-pagination';
import Mapbox from "mapbox-gl";

// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 👇 importa el idioma (español)
import locale from "element-ui/lib/locale/lang/es";

//importando axios
import axios from 'axios'
import VueAxios from 'vue-axios'
import vco from "v-click-outside"
import router from './router'
import store from '@/state/store'
import i18n from './i18n'
import "@/assets/scss/app.scss";
import 'devextreme/dist/css/dx.light.css';
import VueFriendlyIframe from 'vue-friendly-iframe'


Vue.use(ElementUI, { locale });
Vue.use(VueFriendlyIframe)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.use(VueYoutube)
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)
Vue.component('jw-pagination', JwPagination);
Vue.use({ mapboxgl: Mapbox });

// axios.defaults.baseURL = 'http://localhost:3004/';
axios.defaults.baseURL = 'https://admin.abrageo.abracol.co/';

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
